<template>
  <div
    v-if="needWait ? allLoading || singleLoading : isFrameGenerating"
    class="absolute inset-0 flex flex-col justify-center items-center gap-2"
  >
    <div :class="['loading', 'loading-ring', size || 'loading-lg']"></div>
    <template v-if="allPercent! > 0 || singlePercent! > 0">
      {{
        fixNumber(
          needWait ? (allLoading ? allPercent! : singlePercent) : singlePercent,
          1,
          0
        )
      }}%
    </template>

    <div class="text-xs text-center" v-else-if="needWait && isFrameGenerating">
      等待像素小人生成后开始...
    </div>

    <div class="text-xs text-center px-16 text-shadow" v-if="isTask">
      大概 2-5
      分钟就能生成好啦，您可以先离开页面哦，生成完成后会第一时间通知您的～
    </div>
  </div>
</template>

<script setup lang="ts">
import { fixNumber } from "@/components/Mission/MissionStat";

defineProps<{
  needWait: boolean;
  allLoading?: boolean;
  singleLoading?: boolean;
  allPercent?: number;
  singlePercent: number;
  isFrameGenerating: boolean;
  isTask?: boolean;
  size?: "loading-sm" | "loading-md" | "loading-lg";
}>();
</script>
